import React, { Component } from 'react'
import SvgComponent from '../../components/core/SvgComponent'
import SvgFile from './SvgFile'

class ContactPersonIcon extends Component {
  render() {
    return <SvgComponent renderComponent={SvgFile} {...this.props} />
  }
}

export default ContactPersonIcon



// WEBPACK FOOTER //
// ./src/Icons/ContactPersonIcon/index.js